import { inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ResolveFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { authState, authSelectors, authActions } from '@sleipai/sleip-ngrx-store';
import { isEmpty } from 'lodash';
import { filter, take, map, timeout, catchError, of } from 'rxjs';

export const redirectFirstLoginOrPasswordResetCheckResolver: ResolveFn<
  boolean
> = (route, state) => {
  const router = inject(Router);
  const destroyRef = inject(DestroyRef);
  const authStore = inject(Store<authState.State>);

  const isOnAuthPasswordResetRoute = state.url.includes('/auth/password-reset');

  return authStore.select(authSelectors.selectUser).pipe(
    takeUntilDestroyed(destroyRef),
    filter((user) => !isEmpty(user)),
    take(1), // Take first true value
    map((authUser) => {
      if (authUser.userFirstLogin || authUser.didResetPassword) {
        if (isOnAuthPasswordResetRoute) {
          return true;
        } else {
          router.navigate(['auth', 'password-reset']);
          return false;
        }
      } else {
        if (isOnAuthPasswordResetRoute) {
          router.navigate(['']);
          return false;
        }
        return true;
      }
    }),
    timeout(15000), // Timeout after 15 seconds
    catchError(() => {
      authStore.dispatch(authActions.logoutUser());
      router.navigate(['']);
      return of(false);
    }),
  );
};
